import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatMenuTrigger } from '@angular/material/menu';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { UserApiService } from 'src/app/services/api/user-api.service';
import { UserService } from 'src/app/services/user.service';
import { ConfirmDialogComponent } from '../base/confirm-dialog/confirm-dialog.component';
import { FileApiService } from 'src/app/services/api/file-api.service';
import { WalletInfoModalComponent } from '../wallet-info-modal/wallet-info-modal.component';

@Component({
  selector: 'app-user-avatar-menu',
  templateUrl: './user-avatar-menu.component.html',
  styleUrls: ['./user-avatar-menu.component.scss'],
})
export class UserAvatarMenuComponent implements OnInit, OnDestroy {
  @ViewChild('menuTrigger') menuTrigger!: MatMenuTrigger;

  constructor(
    private userService: UserService,
    private router: Router,
    private api: UserApiService,
    private dialog: MatDialog,
    private fileApi: FileApiService
  ) {
    this.sub = this.userService.events.subscribe((r) => {
      this.self = r;
    });
  }

  avatarUrl() {
    return this.self?.avatar
      ? this.fileApi.fileurl(this.self.avatar)
      : '../../../assets/images/empty_avatar.svg';
  }

  self: any = null;
  sub: Subscription;
  ngOnInit(): void {
    this.getSelf();
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  async getSelf() {
    try {
      this.self = await this.userService.getSelf();
    } catch (error) {}
  }

  click() {
    if (this.self) {
      this.menuTrigger.toggleMenu();
    } else {
      this.router.navigateByUrl('/login');
    }
  }

  async logout() {
    this.dialog
      .open(ConfirmDialogComponent, {
        autoFocus: false,
        data: { text: '是否确认退出登录？' },
      })
      .afterClosed()
      .subscribe(async (r) => {
        if (r) {
          await this.api.logout();
          window.location.href = '/';
        }
      });
  }

  openWallet() {
    this.dialog.open(WalletInfoModalComponent, {
      width: '550px',
    });
  }
}
